module.exports = __webpack_public_path__ + "static/media/bellFull.d665f7e9.svg";